import { all, takeEvery, put } from 'redux-saga/effects';
import actions from './actions';

function* loadPayment(payload) {
  try {
    yield put(actions.loadPaymentApiSuccess(payload.pagination, payload.data));
  } catch (error) {
    console.log(error);
    yield put(actions.loadApiError(error));
  }
}

function* storePaymentApi() {
  try {
    yield put({ type: actions.LOAD_PAYMENT_LIST });
  } catch (error) {
    console.log(error);
    yield put(actions.saveApiError(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_PAYMENT_LIST, loadPayment),
    takeEvery(actions.SAVE_PAYMENT_LIST, storePaymentApi)
  ]);
}
